import { render } from "./LibView.vue?vue&type=template&id=54365055"
import script from "./LibView.vue?vue&type=script&lang=js"
export * from "./LibView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__